<template>
  <div>
    <Nav :showMobileSearch="false" />
    <a-spin class="page-load" v-if="pageLoad"/>
    <div class="record-depot" v-else>
      <div class="main-box">
        <div class="home-tit">
          <div class="t-l">
            <span class="name">
              <i class="musician"></i>乐人荟萃
            </span>
          </div>
        </div>
        <div class="result-count">
          <span>共<b>{{rowCount}}</b>人</span>
          <div :class="showMobileFilter?'mb-filter-btn cur':'mb-filter-btn'" @click="showMobileFilter=!showMobileFilter">定位</div>
        </div>
        <div class="py-filter">
          <!-- <span class="lb" @click="goScrollTo('mj')">{{currentLetter}}</span> -->
          <span :class="currentLetter==='名家'?'lb cur':'lb'" @click="goScrollTo('mj')">名家</span>
          <div class="fs">
            <span v-for="item in letterData" :key="item" @click="goScrollTo(item)" :class="currentLetter===item?'cur':''">{{item}}</span>
          </div>
        </div>
        <div class="musician-scroll" @scroll="handleScroll">
          <div class="selection-list">
            <!-- <div class="tit">精选 {{celebritiesRowCount}}</div> -->
            <div class="tit letter-mj">名家(12)</div>
            <div class="celebrities-box">
              <div v-for="(item,index) in celebritiesList" :key="'celebritiesList'+index" class="celebrities">
                <div class="pic" v-if="item.name && item.name['@value']">
                  <router-link :to="'/musician-detail/'+encodeURIComponent(item['@id'])" class="name" v-if="item.name">
                    <img v-if="item.img" :src="item.img" alt="" />
                  <div v-else :class="'base-pic-placeholder bg'+parseInt(Math.random()*6)">
                    {{(item.name['@value']).substring(0,1)}}
                  </div>  </router-link>
                </div>
                <div class="info">
                  <router-link :to="'/musician-detail/'+encodeURIComponent(item['@id'])" class="name" v-if="item.name">
                    {{item.name['@value']}}
                  </router-link>
                  <p v-if="item.briefBiography">
                    <!-- <router-link :to="'/record-detail/'+encodeURIComponent(item['@id'])"> -->
                      {{item.briefBiography}}
                    <!-- </router-link> -->
                  </p>
                  <!-- <p><router-link to="/record-detail/1">{{item.works2}}</router-link></p> -->
                </div>
              </div>
              <div class="clear-f"></div>
            </div>
          </div>
          <div class="letter-show">
            <template v-for="(item,index) in letterData" >
              <div :class="'tit letter-'+item" :key="'letter'+index">
                {{item}}{{'('+personCount[item]+')'}}
              </div>
              <div class="name-list" :key="'name-list'+index">
                <router-link :to="'/musician-detail/'+encodeURIComponent(p['@id'])"
                  v-for="(p,pIndex) in personData[item]" :key="item+'personData'+pIndex">
                  <span v-if="p.name && p.name['@value']">{{p.name['@value']}}</span>
                </router-link>
                <!-- <router-link to="/musician-detail/1">周旋</router-link>
                <router-link to="/musician-detail/1">周旋</router-link>
                <router-link to="/musician-detail/1">周旋</router-link>
                <router-link to="/musician-detail/1">周旋</router-link>
                <router-link to="/musician-detail/1">周旋</router-link>
                <router-link to="/musician-detail/1">周旋</router-link>
                <router-link to="/musician-detail/1">周旋</router-link>
                <router-link to="/musician-detail/1">周旋</router-link>
                <router-link to="/musician-detail/1">周旋</router-link> -->
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <Player ref="player" />
    <div :class="showMobileFilter?'mobile-filter-tk cur':'mobile-filter-tk'" >
      <div class="py-f">
        <span  :class="currentLetter==='名家'?'lb cur':'lb'" @click="goScrollTo('mj'),showMobileFilter=!showMobileFilter" class="lb">名家</span>
        <div class="fs">
          <span v-for="item in letterData" :key="item" @click="goScrollTo(item),showMobileFilter=!showMobileFilter" :class="currentLetter===item?'cur':''">{{item}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from '@/components/player';
import { personFamous, personSearch } from "@/api";

export default {
  components: {
    Nav,
    Footer,
    Player
  },
  data(){
    return {
      pageLoad:false,
      sc:false,
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      searchParams: {}, // 检索参数
      currentLetter:'名家',
      showMobileFilter:false,
      letterData:['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
      rowCount: 0,
      personCount: [],
      personData: [],
      celebritiesRowCount: 0,
      celebritiesList:[],
      params: {
        firstChar: 'A',
        pageSize: 20,
        pageth: 1
      },
      scrollFlag:false
    }
  },
  beforeMount(){
    this.personDataHnandle();
  },
  computed: {
  },
  mounted () {
    this.$nextTick(() => {
      this.query();
      this.personFamousQuery();
    });
  },
  methods:{
    handleScroll(){
      if(this.scrollFlag){
        return
      }
      const st = document.getElementsByClassName('musician-scroll')[0].scrollTop
      this.letterData.forEach((item,index)=>{
        if(index>0){
          const t1 = document.getElementsByClassName('letter-'+(this.letterData[index-1]))[0].offsetTop-250
          const t2 = document.getElementsByClassName('letter-'+(this.letterData[index]))[0].offsetTop-250
          if(st>t1&&st<t2){
            this.currentLetter = this.letterData[index-1]
            return
          }
        }
      })

    },
    async query(firstChar) { // 查询
      this.pageLoad = true
      this.params.firstChar = firstChar;
      const res = await personSearch(this.params);
      if(res){
        this.pageLoad = false
      }
      const result = res.data;
      // this.personData = result.datas;
      this.rowCount = result.pager.rowCount;
    },

    beforeRouteLeave(to, form, next) {
      this.$refs.player.savePlayer()
      next();
    },
    async personDataHnandle() {
      let _this = this;
      _this.letterData.forEach(async (item,index)=>{
        let nowParams = {
          firstChar: item,
          pageSize: 1000,
          pageth: 1
        }
        const res = await personSearch(nowParams);
        _this.$set(_this.personData, item, []);
        if(res.data && res.data.datas) _this.$set(_this.personData, item, res.data.datas);
        else _this.$set(_this.personData, item, []);
        if(res.data && res.data.pager) _this.$set(_this.personCount, item, res.data.pager.rowCount);
        else _this.$set(_this.personCount, item, []);
      })
    },
    schandleCancel(){
      this.sc = false
    },
    async personFamousQuery() { // 精选
      const res = await personFamous();
      const result = res.data;
      this.celebritiesList = result.datas;
      this.celebritiesRowCount = result.pager.rowCount;
      // //console.log(result);
    },
    goScrollTo(a){
      this.currentLetter = a == 'mj' ? '名家' : a;
      this.scrollFlag = true
      if(a==='名家'){
        document.body.scrollTop = document.documentElement.scrollTop = document.getElementsByClassName('musician-scroll')[0].offsetTop-220
      }else{
        document.getElementsByClassName('musician-scroll')[0].scrollTop = document.getElementsByClassName('letter-'+a)[0].offsetTop-250
      }
      setTimeout(()=>{
        this.scrollFlag = false
      },200)
    }
  }
}
</script>
